// Helper function to check if a tooth has information
export const toothHasInfo = (
    toothNumber: number, 
    hasOdontogramFields: boolean, 
    teethData: { toothNumber: number; values: Record<string, string> }[]
  ): boolean => {
    if (!hasOdontogramFields) return false;
  
    const toothData = teethData.find(t => t.toothNumber === toothNumber);
    if (!toothData) return false;
  
    // Check if any dropdown has a value
    return Object.keys(toothData.values).length > 0 &&
      Object.values(toothData.values).some(v => v !== '');
  };